(() => {
  const notificationSelector = '[data-final-sale-notification-notice]';
  let notificationSyncSequence = 0;

  const syncNotificationNotice = async () => {
    const notice = document.querySelector(notificationSelector);
    if (!notice) return;

    const sequence = ++notificationSyncSequence;

    try {
      const response = await fetch(`${window.routes.cart_url}.js`, {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;

      const cart = await response.json();
      if (sequence !== notificationSyncSequence) return;

      notice.hidden = !cart.items.some((item) => {
        const properties = item.properties || {};
        return properties['Sale Type'] === 'Final Sale';
      });
    } catch (error) {
      console.warn('Unable to confirm Final Sale cart state.', error);
    }
  };

  const observeCartNotification = () => {
    const product = document.getElementById('cart-notification-product');
    if (!product) return;

    new MutationObserver(syncNotificationNotice).observe(product, {
      childList: true,
      subtree: true,
    });
    syncNotificationNotice();
  };

  document.addEventListener('DOMContentLoaded', observeCartNotification);
  window.addEventListener('pageshow', syncNotificationNotice);
})();
